<template>
  <el-menu-item v-if="item && hasOnlyOneChild(item) && !item.alwaysShow" :index="resolvePath(onlyOneChild)">
    <i :class="icon" />
    <span>{{ title }}</span>
  </el-menu-item>
  <el-submenu v-else-if="item" :index="resolvePath(item)">
    <template slot="title">
      <i v-if="item.meta" :class="item.meta.icon" />
      <span v-if="item.meta">{{ item.meta.title }}</span>
    </template>
    <SidebarItem
      v-for="(child, index) in item.children"
      :key="child.name || child.path || (child.meta && child.meta.title) || index"
      :item="child"
      :base-path="pathName"
    />
  </el-submenu>
</template>
<script>
import path from "path";
export default {
  name: "SidebarItem",
  props: ["item", "basePath"],
  data() {
    return {
      onlyOneChild: null,
      pathName: "",
    };
  },
  computed: {
    icon() {
      let route = this.onlyOneChild;
      if (route && route.meta && route.meta.icon) {
        return route.meta.icon;
      } else {
        return "";
      }
    },
    title() {
      let route = this.onlyOneChild;
      if (route && route.meta && route.meta.title) {
        return route.meta.title;
      } else {
        return "";
      }
    },
  },
  methods: {
    hasOnlyOneChild(route) {
      // 添加对route的空值检查
      if (!route) return false;
      
      if (!route.children) {
        this.onlyOneChild = route;
        return true;
      }

      if (route.children && route.children.length === 1) {
        this.onlyOneChild = route.children[0];
        return true;
      }

      return false;
    },
    resolvePath(route) {
      // 添加空值检查
      if (!route || !route.path) return this.basePath || '';
      
      this.pathName = path.resolve(this.basePath, route.path);
      return path.resolve(this.basePath, route.path);
    },
  },
};
</script>
<style lang="less" scoped>
</style>